import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_HR.json';
import exercises from './PILATES_EXERCISES_HR.json';
import recipes from './PILATES_RECIPES_HR.json';

export const PILATES_DATA_HR: ServiceData = {
  articles,
  exercises,
  recipes,
};
